<template>
  <filters-dialog v-model="value" :default-filters="defaultFilters">
    <template #activator>
      <e-btn variant="primary" class="books__filters-btn" icon>
        <e-icon name="options" />
      </e-btn>
    </template>
    <template #default="{ items }">
      <books-filters :filters="items" in-modal />
    </template>
  </filters-dialog>
</template>

<script setup lang="ts">
import { useVModel } from '@vueuse/core';
import BooksFilters from './BooksFilters.vue';
import FiltersDialog from '@/core/components/common/FiltersDialog.vue';
import { EBtn, EIcon } from '@/core/components/ui';
import { type BooksFilters as BooksFiltersType, defaultFilters } from '@/parts/books/utils/consts';

const props = defineProps<{
  modelValue: BooksFiltersType;
}>();

defineEmits<{
  (event: 'update:modelValue', value: BooksFiltersType): void;
}>();

const value = useVModel(props, 'modelValue');
</script>

<style scoped lang="scss">
.books {
  &__filters {
    &-btn {
      position: fixed;
      right: 16px;
      bottom: 16px;
    }
  }
}
</style>
